import React from 'react';
import CenterAlignedCell from '../CenterAlignedCell/CenterAlignedCell';

export interface BooleanValueCellProps {
  getValue: () => boolean;
}

const BooleanValueCell = ({ getValue, ...props }: BooleanValueCellProps) => (
  <CenterAlignedCell {...props} getValue={() => (getValue() ? 'X' : '-')} />
);
export default BooleanValueCell;
